import React, { Component } from 'react'
import FileDisplay from 'components/file/file-display'

import {
	formatFileSize,
	hasFailed
} from 'utils'

export default class MessageGroupFile extends Component {
    handleMessageItemMountOrLoad = _ => {
        const {
            version,
            handleMessageItemMountOrLoad
        } = this.props

        const userId = version && version.version ? version.version.user_id : null

        handleMessageItemMountOrLoad(userId)
    }
    
    render() {
        const {
            version,
            incrementVersionsRenderedData,
            openPreviewModal,
            type,
        } = this.props

        if (!version.version) {
            return null
        }

        incrementVersionsRenderedData(version.version)

        return (
            <a 
                className="image-preview" 
                onClick={_ => {
                    openPreviewModal(version.version)
                }} 
                target="_blank"
            >
                <FileDisplay
                    isMini={type == 'message'}
                    onLoadCallback={this.handleMessageItemMountOrLoad}
                    file={version.version}
                />
                <span className="name">
                    {version.file.name} {!version.isLatestVersion && '(earlier version)'}
                    <span className="meta">
                        {hasFailed(version.version) ? 'Upload failed' : formatFileSize(version.version)}
                    </span>
                </span>
            </a>
        )
    }
}
